'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.securityGroup.details.kubernetes', [
  require('./details.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/securityGroup/details/details.kubernetes.module.js